import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

export const potentialColors = ['#924fdc', '#43A3C1', '#50C498', '#1D357E', '#456BD8', '#cfe552'];

export function formatPercentage(decimalPercentage) {
  const percentage = (decimalPercentage || 0) * 100;
  return percentage.toFixed(0);
}

export function NoDataAvailable() {
  return (
    <div className="flex-1 d-flex justify-content-center align-items-center flex-column">
      <FontAwesomeIcon className="no-data-available-icon" icon={faInfoCircle} size="4x"/>
      <div className="no-data-available-text mt-3">
        No Data Available
      </div>
    </div>
  );
}
